<template>
  <div>
    <!-- <O2DHTML v-if="ctx.use2DLabel" @click="() => onClick()" :py="300" class="z-50 cursor-pointer p-1 px-3 text-xs rounded-full bg-white">{{ name }}</O2DHTML> -->
    <!-- <TextClicker :sx="10" :sy="10" :sz="10" :py="200" :text="name"></TextClicker> -->
  </div>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
import { CityItems } from './CityItems.js'
import { LinearEncoding, DoubleSide } from 'three'
let copy2clip = require('copy-to-clipboard')

let cityItems = new CityItems()
export default {
  props: {
    name: {},
    url: {},
    placer: {
      default: false
    }
  },
  mixins: [
    O3DG2
  ],
  data () {
    return {
    }
  },
  async mounted () {
    this.load()
    this.$watch('name', () => {
      this.load()
    })
    this.$watch('url', () => {
      this.load()
    })
  },
  beforeDestroy () {
    this.o3d.children.forEach(e => {
      this.o3d.remove(e)
    })
  },
  methods: {
    onClick () {
      console.log(this.name)
      copy2clip(this.name)
    },
    async load () {
      this.o3d.children.forEach(e => {
        this.o3d.remove(e)
      })

      let item = cityItems.list.find(e => e.name === this.name)
      let url = this.url
      if (item) {
        url = item.url
      }

      let gltf = await CityItems.loadGLTF({ url })
      let first = gltf.scene.children[0]
      if (first) {
        first.position.set(0, 0, 0)
      }

      // // debug
      // if (!this.ctx.scene.ptMesh) {
      //   let geo = new SphereBufferGeometry(10, 3, 3)
      //   let mat = new MeshBasicMaterial({ color: 0xff0000, wireframe: true })
      //   let mesh = new Mesh(geo, mat)
      //   this.ctx.scene.add(mesh)
      //   this.ctx.scene.ptMesh = mesh
      // }

      // let pt = { x: 0, y: 0, z: 0 }

      // this.$root.$on('iso-placer-click', (v) => {
      //   pt = v
      // })

      gltf.scene.traverse((item) => {
        if (item.isMesh) {
          item.material.side = DoubleSide
          // console.log(item.material.name, item.material)
          if (item.material.map) {
            item.material.map.encoding = LinearEncoding
          }
          if (item.material.alphaMap) {
            item.material.alphaMap.encoding = LinearEncoding
          }
          if (item.material.metalnessMap) {
            item.material.metalnessMap.encoding = LinearEncoding
          }
          if (item.material.normalMap) {
            item.material.normalMap.encoding = LinearEncoding
          }
          if (item.material.roughnessMap) {
            item.material.roughnessMap.encoding = LinearEncoding
          }
          if (this.ctx.rayplay && this.placer) {
            this.ctx.rayplay.add(item, (ev) => {
              console.log(this.name, ev)
              this.$root.$emit('placer-pt', ev.event.point)

              let tags = `:scale="{ x: 1 / 100, y: 1 / 100, z: 1 / 100 }" :position="{ x: ${ev.event.point.x.toFixed(2)}, y: ${(ev.event.point.y + 0.01).toFixed(2)} + 31.85 / 100, z: ${ev.event.point.z.toFixed(2)} }"`
              tags = `
    <O3D ${tags}>
      <IsoVisual :name="'Palm_0'"></IsoVisual>
    </O3D>
              `
              copy2clip(tags)
            })
          }
        }
      })
      this.o3d.add(gltf.scene)

    }
  }
}
</script>

<style>

</style>